import { apiClient } from './apiClient';

export const GIOI_TINH_API_END_POINT = "gioi-tinh";

export const gioiTinhApi = {
    selectAll: () => apiClient.get(`${GIOI_TINH_API_END_POINT}`),
};
